import { FleetBodyType, FleetType } from '~/graphql/__generated__/operations/ltms';
import { FLEET_PLATE_COLOR } from '../transporter-fleets/constants';

const DICTIONARIES = {
  en: {
    body_type: 'Fleet Body Type',
    brand: 'Fleet Brand',
    capacity_unit: 'Fleet Capacity Unit',
    capacity: 'Fleet Capacity',
    cluster: 'Fleet Cluster',
    contract_code: 'Vehicle Contract Code',
    fleet: 'Fleet',
    fleets: 'Fleets',
    is_replacement_fleet: 'Is Replacement Fleet',
    new_vehicle_contract_code: 'New Vehicle Contract Code',
    payload: 'Payload',
    plate: 'Fleet Plate',
    plate_number: 'Fleet Plate Number',
    plate_color: 'Fleet Plate Color',
    plate_colors: {
      [FLEET_PLATE_COLOR.BLACK]: 'Black',
      [FLEET_PLATE_COLOR.YELLOW]: 'Yellow',
    },
    replacement_fleet: 'Replacement Fleet',
    replacement_for: 'Replacement For',
    quantity: 'Fleet Quantity',
    replacement: 'Replacement Fleet',
    status: 'Fleet Status',
    sub_type: 'Fleet Sub Type',
    sub_types: {
      [FleetBodyType.Bak]: 'Bak',
      [FleetBodyType.BakAirGalon]: 'Bak Air Galon',
      [FleetBodyType.BakLong]: 'Bak Long',
      [FleetBodyType.BlindVan]: 'Blind Van',
      [FleetBodyType.Box]: 'Box',
      [FleetBodyType.BoxLasah]: 'Box Lasah',
      [FleetBodyType.BoxPallet]: 'Box Pallet',
      [FleetBodyType.BoxReefer]: 'Box Reefer',
      [FleetBodyType.CarCarrier]: 'Car Carrier',
      [FleetBodyType.Dump]: 'Dump',
      [FleetBodyType.Jumbo]: 'Jumbo',
      [FleetBodyType.LongBox]: 'Long Box',
      [FleetBodyType.LongReefer]: 'Long Reefer',
      [FleetBodyType.LosBak]: 'Los Bak',
      [FleetBodyType.MotorCarrierLong]: 'Motor Carrier Long',
      [FleetBodyType.Mpv]: 'MPV',
      [FleetBodyType.PintuSamping]: 'Pintu Samping',
      [FleetBodyType.Reefer]: 'Reefer',
      [FleetBodyType.SelfLoader]: 'Self Loader',
      [FleetBodyType.ThreeWay]: 'Three Way',
      [FleetBodyType.Wingbox]: 'Wingbox',
      [FleetBodyType.XlBox]: 'Xl Box',
    },
    type: 'Fleet Type',
    types: {
      [FleetType.Cdd]: 'CDD',
      [FleetType.Cde]: 'CDE',
      [FleetType.Fuso]: 'Fuso',
      [FleetType.Motorcycle]: 'Motorcycle',
      [FleetType.Pickup]: 'Pickup',
      [FleetType.Tronton]: 'Tronton',
      [FleetType.Van]: 'Van',
      [FleetType.L300]: 'L300',
      [FleetType.Mpv]: 'MPV',
    },
    vehicle_contract_end_date: 'Vehicle Contract End Date',
    vehicle_contract_start_date: 'Vehicle Contract Start Date',
    vehicle_contract_status: 'Vehicle Contract Status',
    verification_statuses: {
      UNVERIFIED: 'Unverified',
      VERIFIED: 'Verified',
      REJECTED: 'Rejected',
      DOCUMENT_EXPIRED: 'Document Expired',
    },
  },
};

export default DICTIONARIES;
